export default "__VITE_ASSET__HEiBZPsY__"